import { AddHubspotCompanyRequestSchema, AddHubspotCompanyResponseSchema } from './add-hubspot-company.schema';
/**
 * Add HubSpot Company Endpoint Contract
 * Creates the CRM record for a customer that has none yet. Super-admin only.
 */ export const addHubspotCompanyContract = {
    method: 'POST',
    path: '/api/v2/admin/hubspot-companies',
    description: 'Create a HubSpot company for a customer that has none',
    requestSchema: AddHubspotCompanyRequestSchema,
    responseSchema: AddHubspotCompanyResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - a name is required',
            401: 'Unauthorized - invalid or missing token',
            403: 'Forbidden - not a super-admin',
            502: 'Bad Gateway - HubSpot API request failed'
        }
    }
};

//# sourceMappingURL=add-hubspot-company.contract.js.map